import { FC } from 'react';
import Modal from '@stripcash/ui-kit/components/Modal';

import { GlobalStateConsumer } from 'common/apps/core/StateConsumer';
import rootSurveySelector from 'common/apps/modules/survey/selectors/rootSurveySelector';
import { SurveyDataProps } from 'common/apps/modules/survey/types';

import SurveyQuestionsModalContainer from './components/SurveyQuestionsModalContainer';

type SurveyQuestionsModalProps = {
  onClose: () => void;
};

const SurveyQuestionsModal: FC<SurveyQuestionsModalProps> = ({ onClose }) => (
  <Modal>
    <GlobalStateConsumer selector={rootSurveySelector}>
      {({ activeStep, surveyData, isSurveySubmitted }) => (
        <SurveyQuestionsModalContainer
          surveyData={surveyData as SurveyDataProps}
          activeStep={activeStep}
          isSurveySubmitted={isSurveySubmitted}
          onClose={onClose}
        />
      )}
    </GlobalStateConsumer>
  </Modal>
);

export default SurveyQuestionsModal;
